import { Injectable } from "@angular/core";
import {
  CanActivate,
  Router,
  UrlTree,
} from "@angular/router";
import { UserService } from "@services/user.service";
import { Observable } from "rxjs";

declare let OneInc: unknown;

@Injectable({
  providedIn: "root",
})
export class OneIncManageWalletGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService
  ) { }

  canActivate(): boolean | UrlTree | Observable<boolean> {
    console.log(this.router.url);
    if (typeof OneInc !== 'undefined') {
      return true;
    }
    this.router.navigate(['/profile']);
    return false;
  }
}
